/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { cloneDeep } from 'lodash';

class AvailableListItem extends Component {
  addItem = () => {
    const { flowListType } = this.props;
    const { id, name } = this.props.item;
    // Find Index of last locked step
    const flowReversed = cloneDeep(this.props.flow).reverse();
    const unlockedIndex = flowReversed.findIndex(s => !s.locked);
    const flow = cloneDeep(this.props.flow);
    // Insert new step before last locked step
    flow.splice(this.props.flow.length - unlockedIndex, 0, { id, name });
    this.props.onChange(flowListType, flow);
  };

  render() {
    return (
      <div className="available-list-item" onClick={this.addItem}>
        <i className="glyphicon glyphicon-plus-sign" /> {this.props.item.name}
      </div>
    );
  }
}

AvailableListItem.propTypes = {
  flow: PropTypes.array,
  flowListType: PropTypes.string,
  item: PropTypes.object,
  onChange: PropTypes.func,
};

export default AvailableListItem;
